module.exports = __webpack_public_path__ + "static/media/new_logo_darwined.6d41182f.svg";